<script>
import { mapGetters, mapActions } from 'vuex';
import CardsListItemAliment from './cards-list-item-aliment';
import ArticlesApi from '@/api/articles';
import { find } from 'lodash';

function outsidePromiseBuilder () {
  let resolve, reject;
  // eslint-disable-next-line promise/param-names
  const promise = new Promise(($resolve, $reject) => { resolve = $resolve; reject = $reject; });
  Object.defineProperty(promise, '$resolve', { value: resolve });
  Object.defineProperty(promise, '$reject', { value: reject });

  return promise;
}

export default {
  name: 'Aliments',
  components: {
    CardsListItemAliment
  },
  data: () => ({
    loading: true,
    modal: false,
    ligneCmd: null
  }),
  computed: {
    ...mapGetters({
      articlesCommandables: 'articles/articlesCommandables',
      tiers: 'user/tiers',
      ref: 'referentiel/referentiel'
    }),
    items () {
      return this.articlesCommandables
        .slice()
        .filter(article => article.codeSousTypeArticle !== 'SU' && article.typeAliment !== 'GSU')
        .sort((a, b) => {
          let order = a.codeSousTypeArticle.localeCompare(b.codeSousTypeArticle);
          return order !== 0 ? order : a.libelle.localeCompare(b.libelle);
        });
    }
  },
  created () {
    this.loadArticlesCommandables(this.tiers.numTiers).then(() => {
      const promises = [];
      this.articlesCommandables.forEach(article => {
        const promise = outsidePromiseBuilder();
        promises.push(promise);

        ArticlesApi.getSupplementations(article.codeTypeArticle, article.numArticle, this.tiers.numTiers)
          .then(
            supplementations => {
              article.supplementations = supplementations;
              promise.$resolve();
            },
            promise.$reject
          );
      });

      Promise.all(promises).finally(() => {
        this.loading = false;
      });
    });
  },
  methods: {
    ...mapActions({ loadArticlesCommandables: 'articles/loadArticlesCommandables', addLineToCart: 'cart/addLine' }),
    getCategorie (item) {
      const departement = find(this.ref.departements, { codeDepartement: item.codeDepartement });
      // let type = '';

      // if (item.codeSousTypeArticle === 'AP' || item.codeSousTypeArticle === 'AA') {
      //   type = 'Aliments';
      // } else if (item.codeSousTypeArticle === 'MI') {
      //   type = 'Minéraux';
      // } else {
      //   type = 'Inconnu [' + item.codeSousTypeArticle + ']';
      // }

      return departement.libelle.toLowerCase().trim().replace(/^\w/, t => t.toUpperCase());
    },
    redirectionLotsPlans (ligne) {
      this.$router.push({ name: 'main.catalog.lots' });
    },
    commandeArticle (item) {
      const ligne = {
        libelleArticle: item.libelle,
        numArticle: item.numArticle,
        codeTypeArticle: item.codeTypeArticle,
        codeDepartement: item.codeDepartement,
        codeUniteArticle: 'T',
        codeFiliere: item.codeFiliere
      };

      this.ligneCmd = ligne;
      this.modal = true;
      this.modalKey++;
    },
    addToCart (ligne) {
      this.modal = false;
      this.addLineToCart(ligne);
      setTimeout(() => {
        this.$dialog.confirm({ text: '<i aria-hidden="true" style="font-size:42px;" class="v-icon notranslate mdi mdi-check-circle-outline theme--light"></i><br/>Le produit a été ajouté à votre panier', actions: { continuer: { text: 'Continuer mes achats ', flat: false }, panier: { text: 'Voir mon panier', color: 'primary', flat: false } } }).then(
          result => {
            if (result === 'panier') {
              this.$router.push({ name: 'main.catalog.cart' });
            }
          }
        );
      });
    },
    isCommandable (article) {
      return !(article.codeSousTypeArticle === 'MI' && article.codeCategorie === '47010');
    }
  }
};
</script>
<template>
  <Loader v-if="loading" />
  <div v-else>
    <h2>
      Aliments
      <CardsHelp
        :page="'ALIMENTS'"
        :niveau="'TITRE'"
      />
    </h2>
    <CardsList
      :items="items"
      :group-by="item=> getCategorie(item)"
    >
      <template v-slot:empty>
        Actuellement, vous ne pouvez commander aucun aliment via ce site internet.
      </template>
      <template v-slot:groupTitle="{group}">
        {{ group }}
      </template>
      <template v-slot:item="{item}">
        <CardsListItemAliment :item="item">
          <template v-slot:actions="{item}">
            <v-btn
              v-if="tiers.hasLots && item.codeFamille && item.codeFamille.startsWith('45')"
              color="secondary"
              outlined
              @click="redirectionLotsPlans(item)"
            >
              <span
                v-if="!isMobile"
                class="action-btn-text ml-1"
              >Lots &amp;<br>plans</span>
              <v-icon>$vuetify.icons.chicken</v-icon>
            </v-btn>
            <v-btn
              v-else
              class="action-btn"
              color="secondary"
              :disabled="!isCommandable(item)"
              @click="commandeArticle(item)"
            >
              <span
                v-if="!isMobile"
                class="action-btn-text"
              >Ajouter</span>
              <v-icon>
                mdi-cart-outline
              </v-icon>
            </v-btn>
          </template>
        </CardsListItemAliment>
      </template>
    </CardsList>
    <v-dialog
      v-if="modal"
      v-model="modal"
      transition="dialog-bottom-transition"
      :fullscreen="isMobile"
      persistent
      scrollable
    >
      <LineEdit
        :line="ligneCmd"
        is-ajout
        @cancel="modal=false"
        @validate="addToCart"
      />
    </v-dialog>
  </div>
</template>
